<svg
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M14.3334 5.40584C12.6089 6.81879 10.4035 7.66667 8.00008 7.66667C5.59667 7.66667 3.3913 6.81879 1.66675 5.40584M1.66675 3H14.3334V13H1.66675V3Z"
    stroke="currentColor"
  />
</svg>
